module.exports = __webpack_public_path__ + "img/start-icon.a1db7227.png";